var _rect, _rect2, _rect3, _path, _rect4, _path2, _rect5, _rect6, _path3, _rect7, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTireTrackLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 0.809,
    width: 11,
    height: 89,
    rx: 5.5,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 10,
    height: 66,
    rx: 5,
    transform: "rotate(-90 0 32)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 19,
    height: 30,
    rx: 4.611,
    fill: "#2F2F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M12 11h1v30h-1zM14 11h1v30h-1zM16 12h1v28h-1zM10 11h1v30h-1zM8 11h1v30H8zM6 11h1v30H6zM4 11h1v30H4zM2 12h1v28H2z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 11,
    width: 19,
    height: 30,
    rx: 4.611,
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M61 11h1v30h-1zM63 11h1v30h-1zM65 12h1v28h-1zM59 11h1v30h-1zM57 11h1v30h-1zM55 11h1v30h-1zM53 11h1v30h-1zM51 12h1v28h-1z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 78,
    width: 9,
    height: 66,
    rx: 4.5,
    transform: "rotate(-90 0 78)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 19,
    height: 30,
    rx: 4.611,
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M12 60h1v30h-1zM14 60h1v30h-1zM16 61h1v28h-1zM10 60h1v30h-1zM8 60h1v30H8zM6 60h1v30H6zM4 60h1v30H4zM2 61h1v28H2z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 60,
    width: 19,
    height: 30,
    rx: 4.611,
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M61 60h1v30h-1zM63 60h1v30h-1zM65 61h1v28h-1zM59 60h1v30h-1zM57 60h1v30h-1zM55 60h1v30h-1zM53 60h1v30h-1zM51 61h1v28h-1z"
  })));
}
export default __webpack_public_path__ + "static/media/tire_track_logo.b900bcbc.svg";
export { SvgTireTrackLogo as ReactComponent };